export const GET_BANNER_DATA: string = "GET_BANNER_DATA";
export const GET_BANNER_DATA_SUCCESS: string = "GET_BANNER_DATA_SUCCESS";
export const GET_BANNER_DATA_FAIL: string = "GET_BANNER_DATA_FAIL";
export const RESET_BANNER_DATA: string = "RESET_BANNER_DATA";
export const HAS_CHANGE: string = "HAS_CHANGE";
export const DISCARD_CHANGES: string = "DISCARD_CHANGES";
export const RESET_HAS_CHANGE: string = "RESET_HAS_CHANGE";
